import type {
  DeleteMachineMutation,
  DeleteMachineMutationVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export const DELETE_MACHINE: TypedDocumentNode<
  DeleteMachineMutation,
  DeleteMachineMutationVariables
> = gql`
  mutation DeleteMachine($input: DeleteMachineInput!) {
    deleteMachine(input: $input) {
      success
      message
    }
  }
`;
